import { computed } from "vue";
import { defineNuxtPlugin, useRuntimeConfig } from "#app";
const plugin = {
  install: (app, options) => {
    app.provide("n-config-provider", {
      mergedThemeHashRef: computed(() => ""),
      mergedBreakpointsRef: computed(() => void 0),
      mergedRtlRef: computed(() => void 0),
      mergedIconsRef: computed(() => void 0),
      mergedComponentPropsRef: computed(() => void 0),
      mergedBorderedRef: computed(() => void 0),
      mergedNamespaceRef: computed(() => void 0),
      mergedClsPrefixRef: computed(() => void 0),
      mergedLocaleRef: computed(() => void 0),
      mergedDateLocaleRef: computed(() => void 0),
      mergedHljsRef: computed(() => void 0),
      mergedThemeRef: computed(() => void 0),
      mergedThemeOverridesRef: computed(() => options.themeOverrides),
      inlineThemeDisabled: false,
      preflightStyleDisabled: false
    });
  }
};
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()?.public?.naiveUI;
  if (config)
    nuxtApp.vueApp.use(plugin, config);
});
